// Accounting Account Payable Vuex

import state from './payableStates.js'
import * as getters from './payableGetters.js'
import * as mutations from './payableMutations.js'
import * as actions from './payableActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
